/*=============================
=          Google Map         =
=============================*/

var mapSection = document.getElementById('section_map');
var mapSectionButton = mapSection && mapSection.querySelector('button');

function initMap() {
    var map,
        openWindow,
        openWindow2,
        ax = axios.create({
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }),
        mapContainer = mapSection.querySelector('#section_map .map2'),
        locationsTable = mapSection.querySelector('.link-table > div:last-child');

    ax.get('map-section').then(function (r) {

        var locations = r.data.locations,
            // center = new google.maps.LatLng(29.9438526,-97.0456837),
            center = new google.maps.LatLng(34.8849303, -84.4980189),
            mapOptions = {
                zoom: checkWidth(768) ? 7 : 7.5,
                streetViewControl: false, // hide the yellow Street View pegman
                scaleControl: true, // allow users to zoom the Google Map
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                scrollwheel: false,
                center: center,
                styles: mapStyles
            };

        map = new google.maps.Map(mapContainer, mapOptions);

        var i = 0;

        locations.forEach(function (location) {

            var coordinates = JSON.parse('[' + location.coordinates.value + ']'),
                latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
                location_code = location.area.value,
                infowindow = new google.maps.InfoWindow({
                    position: latLng,
                    content: location.html
                }),
                marker = new google.maps.Marker({
                    map: map,
                    position: latLng,
                    draggable: false,
                    animation: google.maps.Animation.DROP,
                    icon: '/assets/images/icons/map_pin_' + location_code + '.svg'
                });

            if (i++ === 0) {
                //Open the first location on default
                // openWindow = infowindow;
                // infowindow.open(map, marker);
            }

            marker.addListener('click', function () {
                if (openWindow)
                    openWindow.close();

                if (openWindow2)
                    openWindow2.close();

                if (checkWidth(768))
                    mapContainer.classList.remove('info-closed');

                infowindow.open(map, marker);
                openWindow = infowindow;
            });

            infowindow.addListener('closeclick', function () {
                mapContainer.classList.add('info-closed');
            });
        });

        if (mapSectionButton) {
            mapSection.querySelector('button').addEventListener('click', function () {
                var isOpen = this.classList.contains('expand');

                this.classList.toggle('expand');

                // Velocity(locationsTable, isOpen ? 'slideUp' : 'slideDown', { duration: 300, display: (isOpen ? 'none' : 'flex') });

                // scrollToElement(mapSection.querySelector('.link-table'));

                if (!checkWidth(768)) {
                    setTimeout(function () {
                        map.panBy(0, 214 * (isOpen ? -1 : 1));
                    }, 500);
                }
            });
        }
    });
}

if (mapSection) {
    mapWaypoint(mapSection);

    window.initMap = initMap;
}
